<div class="container">
  <u-icon class="empty-state-icon" [model]="{ type: 'img', value: model.icon }" [styles]="{ width: '160px' }"></u-icon>

  <section class="empty-state-text">
    <div class="title">{{ !model.appLinks.length && model.launcherConnect ? model.launcherConnect.title : model.title.launcher }}</div>
    <div class="subtitle">
      {{ !model.appLinks.length && model.launcherConnect ? model.launcherConnect.subtitle : model.subtitle.launcher }}
    </div>
  </section>
  <u-button
    [label]="model.viewName === 'people' && canReconnectApp && model.appLinks.length > 0 ? 'Go to settings' : 'Connect now'"
    type="primary"
    elementSize="large"
    [styles]="{ width: '256px', zIndex: '1' }"
    (click)="onButtonClick()"
    data-cy="connect-button"
  ></u-button>
</div>
